export default __webpack_public_path__ + "static/writing-331a91efcd42027a15d75a949e58625e.png";